import React from 'react'
import { Divider,Image} from 'semantic-ui-react'
import { Nav,Navbar, Container,Col,Row} from 'react-bootstrap'


function Header() {
    return (
        <div>
           <Navbar collapseOnSelect expand="lg" bg="lg" variant="dark">
  <Container>
  <Navbar.Brand href="#home">
  <img src='./images/vasiti-logo.svg' alt='Vasiti Logo' />  
  </Navbar.Brand>
  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <Navbar.Collapse id="responsive-navbar-nav">
    <Nav className="me-auto">           
    </Nav>
    <Nav>
      <Nav.Link href="/">ABOUT US</Nav.Link>
      <Nav.Link href="/">STORIES</Nav.Link>
      <Nav.Link href="/">CONTACT</Nav.Link>
      <Nav.Link href="/">LOGIN</Nav.Link>
      <Nav.Link href="/" className="button button1">SIGN UP</Nav.Link>                
    </Nav>
      </Navbar.Collapse>    
  </Container> 
</Navbar>
<Divider className='divider'/>
<ul id='list' className='container'>
           <li>MARKETPLACE</li>
           <li>WHOLESALE CENTER</li>
           <li>SELLER CENTER</li>
           <li>SERVICES</li>
           <li>INTERNSHIPS</li>
           <li>EVENTS</li>
       </ul>
       <Divider/>
       <Row>
    <Col sm={6}>
       <div className='firstdiv'>
            <h1>Amazing <br/>
        Experiences from Our <br/> Wonderful Customers</h1>
        <p>Here is what customers and vendors are saying about
         us, you can share your stories with us too.</p>      
              </div>
              </Col>
    <Col sm={6}>
    <div className='firstImg'>
      <Image src='/images/heroImg-des.png' />
      </div>
      <div className='mobileFirst'>
      <Image src='/images/Hero1.png' />
      </div>
    </Col></Row>
       
            </div>
      
    )
}

export default Header
